<script setup lang="ts">
import ApplicationBase from '@/components/Applications/ApplicationBase.vue'

// Steps (reuse your existing components; just ensure these paths match your structure)
import BeginStep from './Steps/LanGreidslufrestBegin.vue'
import Umsaekjandi from '../Shared/Umsaekjandi.vue'
import Step2 from './Steps/Step2.vue'
import Step3 from './Steps/Step3.vue'
import Step4 from './Steps/Step4.vue'
import Step5 from './Steps/Step5.vue'
import Step6 from './Steps/Step6.vue'
import Step7 from './Steps/Step7.vue'
import PEP from '../Shared/PEP.vue'
import Undirritun from '../Shared/Undirritun.vue'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'
import { watch } from 'vue'

const { umsokn } = useUmsokn()

// App constants (14 = Lán greiðslufrestur in your legacy code)
const APP_ID = 14
const UPDATE_KEY = 'langreidslufrest' // used by ApplicationBase to persist progress

watch(
  () => umsokn.value,
  () => {
    if (!umsokn.value) return

    if (!umsokn.value.coDeptors) umsokn.value.coDeptors = []
    if (!umsokn.value.loanInformation) umsokn.value.loanInformation = []
  }
)

const steps = [
  { comp: BeginStep,   titleKey: '' },

  { comp: Umsaekjandi, titleKey: 'lan_greidslufrest_umsokn_step1_header' },

  // Intermediate data steps (use your internal headings or provide keys if you have them)
  { comp: Step2,       titleKey: 'lan_greidslufrest_umsokn_step2_header1' },
  { comp: Step3,       titleKey: 'lan_greidslufrest_umsokn_step3_header' },
  { comp: Step4,       titleKey: 'lan_greidslufrest_umsokn_step4_header' },
  { comp: Step5,       titleKey: 'lan_greidslufrest_umsokn_step5_header' },

  // PEP (disclaimer ON) — same as your legacy step 6
  { comp: PEP,         titleKey: 'umsokn_PEP_header', props: { showDisclamer: true } },

  // Remaining data steps
  { comp: Step6,       titleKey: 'lan_greidslufrest_umsokn_step6_header' },
  { comp: Step7,       titleKey: 'umsokn_samantekt_header' },

  // Signing (legacy step 9) — trigger document creation inside this component
  { comp: Undirritun,  titleKey: 'undirritun_umsokn_header1' },

  // Final step (legacy step 10)
//   { comp: LokaSkref,   titleKey: 'umsokn_lokaskref_header', props: { cosigner: true } },
]
</script>

<template>
  <ApplicationBase :app-id="APP_ID" :update-key="UPDATE_KEY" :steps="steps" />
</template>
